import { render, staticRenderFns } from "./red-wine-light-medium.vue?vue&type=template&id=f57c61cc"
import script from "./red-wine-light-medium.vue?vue&type=script&lang=js"
export * from "./red-wine-light-medium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports